module.exports = __webpack_public_path__ + "img/poly-6.e950d765.png";